import { instance } from '../../util/http'
import apis from '../../config/apis'

const get = () => {
    return instance.get(apis.Group.Get)
}

const getChild = (id,page,size) => {
    return instance.get(apis.Group.Child.Get  + "?groupCode=" + id + "&page=" + page + "&limit=" + size)
}

const getNestChildren = (id) => {
    return instance.get(apis.Group.Child.Nest.Get + id)
}

const getChildItems = (id,code, page, size) => {
    return instance.get(apis.Group.Child.Item.Get + "?groupCode=" + id + "&childCode=" + code + "&page=" + page + "&limit=" + size)
}

export default {
    get,
    getChild,
    getNestChildren, getChildItems
}